export default function ElRetoSection() {
  return (
    <section className="py-16 bg-municipal-dark relative overflow-hidden" data-testid="elreto-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center gap-10">
        <img
          src="/logos/el-reto-logo.png"
          alt="El Reto — campaña de reciclaje de San Fernando de Henares"
          className="h-20 sm:h-28 w-auto shrink-0"
          data-testid="elreto-logo"
        />
        <div className="text-center md:text-left">
          <span className="text-dorado-light font-semibold text-sm uppercase tracking-widest">
            Campaña municipal
          </span>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl text-white mt-2 mb-4">
            ¿Ya conoces El Reto?
          </h2>
          <p className="text-white/85 leading-relaxed max-w-2xl" data-testid="elreto-bonificacion-text">
            Los/as vecinos/as acogidos/as a El Reto recibirán una bonificación de 50 euros. San Fernando de
            Henares es el municipio que mayor reducción ofrece, más de un 30% de rebaja, por su colaboración
            y compromiso con una ciudad más verde y sostenible.
          </p>
        </div>
      </div>
    </section>
  );
}
